import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import styled from 'styled-components';
const Container = styled.section `
  --sectionBackground: transparent;
  --sectionColour: ${brand.global.black};
  --sectionTitleColour: ${brand.global.black};

  scroll-margin: calc(var(--headerHeight, 0px) + ${fluid(16, 32)}) 0 0;
  color: var(--sectionColour);
  background-color: var(--sectionBackground);

  /* Background.Teal */
  &[data-background='teal'] {
    --sectionBackground: ${brand.primary.teal.tealBg};
  }

  /* Background.Pear */
  &[data-background='pear'] {
    --sectionBackground: ${brand.primary.pear.pearBg};
  }

  /* Background.Blue */
  &[data-background='blue'] {
    --sectionBackground: ${brand.primary.blue.blueBg};
  }

  /* Background.DarkBlue */
  &[data-background='dark-blue'] {
    --sectionBackground: ${brand.accent.darkBlue.darkBlueBg};
  }

  /* Background.ForrestGreen */
  &[data-background='forrest-green'] {
    --sectionBackground: ${brand.accent.forrestGreen.forrestGreenBg};
  }

  /* Background.Purple */
  &[data-background='purple'] {
    --sectionBackground: ${brand.secondary.purple.purpleBg};
  }

  /* Background.Yellow */
  &[data-background='yellow'] {
    --sectionBackground: ${brand.secondary.yellow.yellowBg};
  }

  /* Background.Orange */
  &[data-background='orange'] {
    --sectionBackground: ${brand.secondary.orange.orangeBg};
  }

  /* Background.EngageGreen */
  &[data-background='engage-green'] {
    --sectionBackground: ${brand.engagePrimary.green.green25};
  }

  /* Background.EngageSeaGreen */
  &[data-background='engage-sea-green'] {
    --sectionBackground: ${brand.engagePrimary.seaGreen.seaGreen25};
  }

  /* Background.EngageTeal */
  &[data-background='engage-teal'] {
    --sectionBackground: ${brand.engagePrimary.teal.teal25};
  }

  /* Background.EngageLime */
  &[data-background='engage-lime'] {
    --sectionBackground: ${brand.engagePrimary.lime.lime25};
  }

  /* Background.EngageSky */
  &[data-background='engage-sky'] {
    --sectionBackground: ${brand.engagePrimary.sky.sky25};
  }

  /* Background.EngagePurple */
  &[data-background='engage-purple'] {
    --sectionBackground: ${brand.engageSecondary.purple.purple25};
  }

  /* Background.EngageLilac */
  &[data-background='engage-lilac'] {
    --sectionBackground: ${brand.engageSecondary.lilac.lilac25};
  }

  /* Background.EngageTangerine */
  &[data-background='engage-tangerine'] {
    --sectionBackground: ${brand.engageSecondary.tangerine.tangerine25};
  }

  /* Background.EngageLavender */
  &[data-background='engage-lavender'] {
    --sectionBackground: ${brand.engageSecondary.lavender.lavender25};
  }

  /* Background.EngagePink */
  &[data-background='engage-pink'] {
    --sectionBackground: ${brand.engageSecondary.pink.pink25};
  }

  /* Background.EngageYellow */
  &[data-background='engage-yellow'] {
    --sectionBackground: ${brand.engageSecondary.yellow.yellow25};
  }

  /* Background.EngageDusk */
  &[data-background='engage-dusk'] {
    --sectionBackground: ${brand.engageNeutral.dusk};
  }

  /* Background.EngageCream */
  &[data-background='engage-cream'] {
    --sectionBackground: ${brand.engageNeutral.cream};
  }

  /* Background.White */
  &[data-background='white'] {
    --sectionBackground: ${brand.global.white};
  }

  /* Background.Bronze */
  &[data-background='bronze'] {
    --sectionBackground: ${brand.awards.bronze.bronzeBg};
  }

  /* Background.Silver */
  &[data-background='silver'] {
    --sectionBackground: ${brand.awards.silver.silverBg};
  }

  /* Background.Gold */
  &[data-background='gold'] {
    --sectionBackground: ${brand.awards.gold.goldBg};
  }


  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }
`;
const Inner = styled.div `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
const FocusAnchor = styled.button `
  ${ButtonReset};

  height: 0;
  width: 0;
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    FocusAnchor,
};
export default SectionWrapperStyles;
